import BadgeForTable from "components/shared-components/BadgeForTable";
import React from "react";
import { useTranslation } from "react-i18next";
import { Button, UncontrolledTooltip } from "reactstrap";

const formatAuthStatus = cell => {
  switch (cell) {
    case "A":
      return <BadgeForTable badgeColor={"success"}>Sử dụng</BadgeForTable>;
    case "M":
      return <BadgeForTable badgeColor={"info"}>Chưa sử dụng</BadgeForTable>;
    default:
      return "";
  }
};

const useTable = ({ params, setParams }) => {
  const { t } = useTranslation(["customer"]);

  const columnTable = [
    {
      dataField: "code",
      text: "Mã",
      sort: true,
      formatter: (_cell, row) => {
        return (
          <div className="d-flex align-items-center gap-1">
            {row?.code}
            <Button
              id={`order_code_copy_${row?.code}`}
              size="sm"
              color=""
              className="bg-light"
              onClick={e => navigator.clipboard.writeText(row?.code)}
            >
              <i className="far fa-copy fa-md text-secondary" />
            </Button>
            <UncontrolledTooltip
              placement="top"
              target={`order_code_copy_${row?.code}`}
            >
              Copy
            </UncontrolledTooltip>
          </div>
        );
      },
    },
    {
      dataField: "auth_status",
      text: "Trạng thái",
      sort: true,
      formatter: (_cell, row) => {
        return formatAuthStatus(row?.auth_status);
      },
    },
    {
      dataField: "checker_date",
      text: "Ngày cập nhật",
      sort: true,
      formatter: (cell, row) => {
        if (cell) {
          return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }).format(Number(cell) * 1000);
        } else {
          return "";
        }
      },
    },
  ];

  const onTableChange = (_type, value) => {
    setParams(prev => ({
      ...prev,
      page: value.page,
      sizePerPage: value.sizePerPage,
      sort: `${value.sortOrder}${value.sortField}`,
    }));
  };

  const onSearchAllHandle = value => {
    setParams(prev => ({
      ...prev,
      searchContent: value,
    }));
  };

  return {
    columnTable,
    onTableChange,
    onSearchAllHandle,
  };
};

export default useTable;
